module.exports = __webpack_public_path__ + "static/media/kiera-knightly.7259be16.jpg";